import $ from 'jquery';


let wc = {

    $product_tabs : $('.product_tabs'),

    init(){
        this.$product_tabs.find('h4').click((e) => {
            $(e.currentTarget).addClass('active');
            $(e.currentTarget).siblings().removeClass('active');
            var active_tab_head = $(e.currentTarget).attr('id');

            var active_tab_content = '#'+active_tab_head+'-content';
            $(active_tab_content).addClass('active');
            $(active_tab_content).siblings().removeClass('active');
            console.log(active_tab_content);
        });
    },

    clickModal(){
        if( !$('#size-chart') ){return;}

        $('#size-chart').click(function(e){
            e.preventDefault();
            $('html').css('overflow-y','hidden');
            $('#size-chart-modal').fadeIn();
        });
        
        $('.modal-close').click(function(e){
            e.preventDefault();
            $('html').css('overflow-y','scroll');
            $('.modal').fadeOut();
        });
    }

}
export default wc;